import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { initTelemetry } from './lib/telemetry';
import { createLogger } from './lib/debug';
import './index.css';

const log = createLogger('boot');
log.log('main.tsx executing');
initTelemetry();
log.log('telemetry initialized');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
